module.exports = __webpack_public_path__ + "static/lemonade-23c482aba01f6dadde0e62ac0b5e3604.png";